import { GoalType } from '@griply/types';
import { Paths } from 'shared/routes/paths';
import { Goal } from 'shared/types/goal';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

// An absent or unrecognised type is a goal.
export const getGoalDetailUrl = ({
  id,
  type,
}: Pick<Goal, 'id'> & Partial<Pick<Goal, 'type'>>): string =>
  replaceUrlParams(
    type === GoalType.Project ? Paths.ProjectDetail : Paths.GoalDetail,
    { id },
  );
